import { render, staticRenderFns } from "./ModalEditItem.vue?vue&type=template&id=2d04b8b6&scoped=true&"
import script from "./ModalEditItem.vue?vue&type=script&lang=js&"
export * from "./ModalEditItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditItem.vue?vue&type=style&index=0&id=2d04b8b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04b8b6",
  null
  
)

export default component.exports